module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CheckoutSteps":{"cart":"Nákupní košík","finished":"Objednávka dokončena","information":"Vaše údaje","shippingAndPayment":"Doprava a platba"}},"en":{"CheckoutSteps":{"cart":"Shopping cart","finished":"Order completed","information":"Your data","shippingAndPayment":"Shipping and Payment"}}}')
  delete Component.options._Ctor
}
